import { Component, inject, input } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { FormatPipe } from '@pipe/format.pipe';

@Component({
  selector: 'afcu-breadcrumbs',
  standalone: true,
  imports: [FormatPipe],
  templateUrl: './breadcrumbs.component.html'
})
export class BreadcrumbsComponent extends BaseConfigurableComponent{

  private stepService = inject( SchedulerStepService );
  branchView = input.required<boolean>()
  appointment = input.required<boolean>()
  target = ''
  
  constructor() {
    super('breadcrumbs')
  }

  get actualStep () {
    return this.stepService.actualStep()
  }

  get totalStep () {
    return this.stepService.totalStep
  }
}


